import { useEffect, useState } from 'react';
import { CheckRounded, ExpandMore, LanguageOutlined } from '@mui/icons-material';
import { Box, Popover, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JoveInternationalizationLanguageSwitchView = function JoveInternationalizationLanguageSwitchView(props) {
  var _canSelectLanguageLis;

  var className = props.className,
      _props$languageList = props.languageList,
      languageList = _props$languageList === void 0 ? [] : _props$languageList,
      value = props.value,
      valueChange = props.valueChange,
      textColor = props.textColor;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(null),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = useState(languageList),
      canSelectLanguageList = _useState3[0],
      setCanSelectLanguageList = _useState3[1];

  var _useState4 = useState(value),
      selectedLanguage = _useState4[0],
      setSelectedLanguage = _useState4[1];
  /**
   * effects
   */


  useEffect(function () {
    setCanSelectLanguageList(languageList || []);
  }, [languageList]);
  useEffect(function () {
    setSelectedLanguage(value);
  }, [value]);
  /**
   * methods
   */

  var openSwitchLanguageAction = function openSwitchLanguageAction(event) {
    setIsOpen(true);
    setAnchorEl(event.currentTarget);
  };

  var closeSwitchLanguageAction = function closeSwitchLanguageAction() {
    setAnchorEl(null);
    setIsOpen(false);
  };

  var selectLanguageAction = function selectLanguageAction(item) {
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(item === null || item === void 0 ? void 0 : item.value);
    closeSwitchLanguageAction();
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [/*#__PURE__*/_jsxs("button", {
      role: "button",
      onClick: openSwitchLanguageAction,
      className: clsx('pointer group flex items-center self-center rounded-full border-2 px-3 py-2 transition-all duration-300 ease-out hover:border-stone-600', isOpen && 'border-stone-600 bg-gray-100'),
      children: [!selectedLanguage ? /*#__PURE__*/_jsx(LanguageOutlined, {}) : null, /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: clsx('font-medium'),
        sx: {
          color: textColor || '#000'
        },
        children: (_canSelectLanguageLis = canSelectLanguageList.find(function (item) {
          return item.value === selectedLanguage;
        })) === null || _canSelectLanguageLis === void 0 ? void 0 : _canSelectLanguageLis.label
      }), /*#__PURE__*/_jsx(ExpandMore, {
        className: clsx('w-5 text-stone-400 transition-all duration-300 ease-out group-hover:text-stone-900', isOpen && 'rotate-180 text-stone-900')
      })]
    }), /*#__PURE__*/_jsx(Popover, {
      id: "jove-internationalization-language-switch-popover",
      open: Boolean(anchorEl),
      anchorEl: anchorEl,
      onClose: closeSwitchLanguageAction,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: -130
      },
      className: "rounded-2xl",
      children: /*#__PURE__*/_jsx(Box, {
        className: "flex w-[200px] flex-col p-2 text-left",
        children: canSelectLanguageList.map(function (item) {
          var selected = selectedLanguage === item.value;
          return /*#__PURE__*/_jsxs(Box, {
            onClick: function onClick() {
              return selectLanguageAction(item);
            },
            className: clsx('flex cursor-pointer flex-row items-center space-x-2 rounded-sm p-2 text-left text-sm font-medium transition-all duration-300 ease-out hover:bg-slate-100', selected && 'bg-slate-100'),
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "subtitle2",
              className: "w-0 flex-1 font-medium",
              children: item.label
            }), selected && /*#__PURE__*/_jsx(CheckRounded, {
              className: "ml-auto w-4"
            })]
          }, item.value);
        })
      })
    })]
  });
};